
import { AuthService } from "@/services";
import { InboxreaderPurchase } from "@/utils/purchase/inboxreader-purchase";
import { InboxreaderPurchaseFile } from "@/utils/purchase/inboxreader-purchase-file";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		purchase: {
			type: Object as ()=>InboxreaderPurchase,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			let fileName = "UNKOWN";
			for (let file of this.purchase.Files) {
				if (file.File) {
					fileName = file.File.Name;
					break;
				}
			}
			return this.$ct("all-attachments-of", {purchase: fileName});
		},
		files():InboxreaderPurchaseFile[] {
			return this.purchase.Files.filter(f=>f.File != null);
		},
		isDevMode():boolean {
			return AuthService.isDevModeEnabled;
		}
	},
	methods: {
		download(file:InboxreaderPurchaseFile){
			this.$emit("download", file);
		},
		send(file:InboxreaderPurchaseFile){
			let purchase = new InboxreaderPurchase(file.getJSON());
			purchase.Files = [new InboxreaderPurchaseFile(file.getJSON())];
			this.$emit("send-mail", purchase);
			this.close();
		},
		open(file:InboxreaderPurchaseFile){
			this.$emit("preview-file", file);
		},
		close(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
